import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#f0873c', light: '#f5a76c', dark: '#c96820' },
    secondary: { main: '#6bb07a', light: '#8fc99d', dark: '#4a8a58' },
    background: { default: '#0c0b09', paper: '#1c1a16' },
    text: { primary: '#f5f0eb', secondary: '#a89880' },
    error: { main: '#ef5350' },
    success: { main: '#66bb6a' },
    warning: { main: '#ffa726' },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", sans-serif',
    h4: { fontWeight: 800 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none', border: '1px solid rgba(255,255,255,0.06)' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500 },
      },
    },
  },
});
